import React from 'react';
import PropTypes from 'prop-types';

import { InlineInfoAlert } from '@bingads-webui-cc-react/alert';
import { ReactTemplate } from '@bingads-webui-react/react-template';

export const BillingGroupAlert = ({ i18n }) => (
  <InlineInfoAlert className="abl-billing-group-alert">
    <ReactTemplate
      model={{ bold: text => <b>{text}</b> }}
      template={i18n.getString(_TL_('If you change the business location (country, state/province, city), this account will be removed from its current billing group. If you still want consolidated monthly invoicing for this account, please go to {{bold}}Billing settings{{/bold}} and add the account to an appropriate billing group.'))}
    />
  </InlineInfoAlert>
);

BillingGroupAlert.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
